import { EditorContent, useEditor } from "@tiptap/react";
import { useMemo } from "react";
import { tiptapExtensions, textToDoc } from "@shared/tiptap-doc";

interface RichTextProps {
  /** Stored tiptap JSON string (source of truth). */
  doc: string | null;
  /** Plaintext fallback for legacy / pre-backfill rows (converted client-side). */
  fallbackText?: string | null;
  className?: string;
}

/** Read-only tiptap renderer. Content goes through the same schema as the editor
 * and the server validator — no dangerouslySetInnerHTML. */
export function RichText({ doc, fallbackText, className }: RichTextProps) {
  const content = useMemo(() => {
    if (doc) {
      try {
        return JSON.parse(doc);
      } catch {
        /* fall through to plaintext */
      }
    }
    return textToDoc(fallbackText ?? "");
  }, [doc, fallbackText]);

  const editor = useEditor({ editable: false, extensions: tiptapExtensions, content }, [content]);
  if (!editor) return null;
  return <EditorContent editor={editor} className={`prose prose-invert prose-sm max-w-none ${className ?? ""}`} />;
}
